export const FlightServiceTemp =  {
  "id": "",
  "price": "",
  "name": "",
  "icon": "",
  "description": "",
  "createdDate": "",
  "updatedDate": ""
}